<!-- Valid token - change password -->
@if (validToken) {
  <div>
    <h2>Återställ lösenord</h2>
    <div class="content-wrapper">
      @if (newPassForm) {
        <form [formGroup]="newPassForm" (ngSubmit)="submit()">
          @if (!resetFinished) {
            <mat-form-field>
              <input matInput name="newPass" formControlName="newPass" type="password" placeholder="Nytt lösenord"
                spellcheck="false" autocomplete="off">
              </mat-form-field>
            }
            @if (!resetFinished) {
              <mat-form-field>
                <input matInput name="repeatPass" formControlName="repeatPass" type="password" placeholder="Upprepa lösenord"
                  spellcheck="false" autocomplete="off">
                </mat-form-field>
              }
              @if (message) {
                <p>{{message}}</p>
              }
              @if (!resetFinished) {
                <button class="button" [disabled]="!newPassForm.valid" type="submit">Byt lösenord</button>
              }
            </form>
          }
          <button class="button" (click)="toLogin()">Tillbaka till logga in</button>
        </div>
      </div>
    }

    <!-- Invalid token info -->
    @if (!validToken) {
      <div>
        <h2>Ogiltig länk</h2>
        <p>Någonting gick fel. Antingen har din länk gått ut, eller så är den felaktig. Prova igen.</p>
      </div>
    }